import * as React from "react";
import { ArrowUpDown, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./library/dropdown-menu";
import { Button } from "./button";
import { cn } from "@/lib/utils";

const MENU_ITEMS = [
  { label: "Recent", value: "Recent" },
  { label: "All", value: "All" },
  { label: "Starred", value: "Starred" },
  { label: "My Leads (20) sdfsdfsadf", value: "My Leads (20) sdfsdfsadf" },
  { label: "Archived", value: "Archived" },
];

type MenuItem = { label: string; description?: string };

interface SortDropdownProps {
  value?: string;
  menuItems?: MenuItem[];
  onSelect?: (label: string) => void;
  className?: string;
  isIconShow?: boolean;
}

export function SortDropdown({
  value,
  menuItems = MENU_ITEMS,
  onSelect,
  className,
  isIconShow = true,
}: SortDropdownProps): React.ReactElement {
  const resolvedValue = value ?? menuItems[0]?.label ?? "";
  const [selectedValue, setSelectedValue] =
    React.useState<string>(resolvedValue);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value);
    }
  }, [value]);

  const handleSelect = (label: string) => {
    setSelectedValue(label);
    onSelect?.(label);
    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="filter"
          className={cn("w-[8.5rem] shrink-0", className)}
        >
          <span className="inline-flex items-center gap-3 min-w-0 overflow-hidden">
            {isIconShow && (
              <span className="inline-flex h-5 w-5 items-center justify-center shrink-0">
                <ArrowUpDown className="h-5 w-5 text-[var(--color-black-9)]" />
              </span>
            )}
            <span className="text-b4 font-medium leading-[normal] text-[var(--color-black-9)] overflow-hidden text-ellipsis whitespace-nowrap">
              {selectedValue}
            </span>
          </span>
          <ChevronDown
            className={cn(
              "h-5 w-5 text-[var(--color-black-9)] shrink-0 ml-2 transition-transform duration-200",
              open && "rotate-180"
            )}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn(
          "min-w-[var(--radix-dropdown-menu-trigger-width)] w-max max-w-[16rem] rounded-[16px] border border-[var(--color-black-2)] bg-[var(--color-white)] p-1 shadow-sm"
        )}
        align="start"
      >
        {menuItems?.map((item) => (
          <DropdownMenuItem
            key={item.label}
            onClick={() => handleSelect(item.label)}
            title={item.description}
            className={cn(
              "flex w-full items-start gap-2 rounded-[12px] px-2.5 text-left transition-colors cursor-pointer",
              item.description ? "py-2" : "h-9 items-center",
              selectedValue === item.label
                ? "bg-[var(--color-green-2)] text-[var(--color-black-9)]"
                : "text-[var(--color-black-8)] hover:bg-[var(--color-green-1)]"
            )}
          >
            <div className="flex flex-col min-w-0">
              <span className="text-b4 leading-[19px] overflow-hidden text-ellipsis whitespace-nowrap">
                {item.label}
              </span>
              {item.description && (
                <span className="text-[10px] leading-tight text-[var(--color-black-4)] font-normal mt-0.5">
                  {item.description}
                </span>
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
